export const EmailLogStatus = {
    Sent: "S",
    Pending: "P",
    Failed: "F"
  };